export const FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_COMPONENT_SELECT = 'FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_COMPONENT_SELECT';

export const selectFileMappingWizardCubeComponentListComponent = cubeComponentCode => ({
  type: FILE_MAPPING_WIZARD_CUBE_COMPONENT_LIST_COMPONENT_SELECT,
  cubeComponentCode
});



// WEBPACK FOOTER //
// ./src/scenes/data-manager/file-mapping/wizard/cube-component-list/actions.js